import { observer } from "mobx-react-lite";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { IOption, SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import { NOTE_TYPE, Note } from "../../../../../../components/note/note";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import config  from "../../../../../../config";
import ReturnMethodStore from "../../../../stores/return-method-store";
import { InstrucionsWarningFieldLine } from "../../instructions-warning";
import { ShippingInstructionsChangeTrigger } from "../../../../return-method-types";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";

interface IConnectionFieldsProps {
    returnMethodStore: ReturnMethodStore,
    validationGroup: IValidationGroup;

}
const ConnectionSelector: React.FC<IConnectionFieldsProps> = observer(({ returnMethodStore, validationGroup }: IConnectionFieldsProps) => {
    const shippingLabelStore = returnMethodStore.shippingLabelSetting;
    const aggregatorsList =  shippingLabelStore?.populateAggregatorsList().sort((a,b)=> a.label > b.label ? 1 : -1) as IOption[];

    const selectedAggregator = () => {
        const connectionId = shippingLabelStore?.shippingConnectionId;
        if (!connectionId) {
            return undefined;
        }
        return aggregatorsList.find( aggregator => aggregator.value === connectionId)
    }

    const onConnectionChange = (v: number) => {
        shippingLabelStore?.setShippingConnectionId(v);
    }

    const labelSettingsNote = shippingLabelStore?.getLabelSettingsNote();
    const infoNoteText = labelSettingsNote
        ? <span dangerouslySetInnerHTML={{__html: labelSettingsNote}} />
        : <>Connect additional carriers from the <a href={`${config.apiUrl}/dashboard/settings/integrations/products-services`} target="_parent">integrations page.</a></>;

    return (
        <>
            <FormFieldLine
                label="Connection"
                note="Choose which of your shipping service accounts to use."
            >
                <SelectDropdown
                    value={selectedAggregator()}
                    options={aggregatorsList}
                    onChange={(v) => onConnectionChange(v?.value as number)}
                    required
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            <InstrucionsWarningFieldLine returnMethod={returnMethodStore} trigger={ShippingInstructionsChangeTrigger.SHIPPING_CONNECTION} />

            <FormFieldLine label="">
                <Note
                    type={NOTE_TYPE.INFORMATION}
                    body={
                        <FontBody2>{infoNoteText}</FontBody2>
                    }
                />
            </FormFieldLine>
        </>
    )
})

export default ConnectionSelector;